module.exports = __webpack_public_path__ + "img/04.3245a64c.png";